import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Formly field type for a single boolean switch — same semantics as
 * `type: 'checkbox'`, styled as a sliding toggle rather than a checkbox
 * square. Use for a standing setting/flag (e.g. "Do Not Call"), not for a
 * form-submission consent checkbox.
 */
@Component({
  selector: 'app-toggle-field',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule],
  templateUrl: './toggle-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toggle-field.component.css',
})
export class ToggleFieldComponent extends FieldType<FieldTypeConfig> {}
